import React, { useState } from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@material-ui/core';

import { ICustomSelectSimple } from './interface';

const CustomSelectSimple: React.FC<ICustomSelectSimple> = ({
  options,
  ...props
}) => {
  const [fieldValue, setFieldValue] = useState<unknown>(
    props.defaultValue || '',
  );

  const handleChange = (
    event: React.ChangeEvent<{
      value: unknown;
    }>,
    child: React.ReactNode,
  ) => {
    props.onChange && props.onChange(event, child);
    setFieldValue(event.target.value);
  };
  const id = `select-simple${props.name ? '--' + props.name : ''}`;
  const labelId = `select-simple-label${props.name ? '--' + props.name : ''}`;

  return (
    <FormControl variant="outlined" fullWidth>
      {props.label && <InputLabel htmlFor={labelId}>{props.label}</InputLabel>}
      <Select
        id={id}
        labelId={labelId}
        onBlur={undefined}
        {...props}
        onChange={handleChange}
        value={fieldValue}
      >
        {options.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelectSimple;
